import SupervisorDataVisuals from "../Supervisor/SupervisorDataVisuals";

function AdminData({ worker }) {
  return <SupervisorDataVisuals worker={worker} />;
}

export default AdminData;
